var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIkonaTerminarz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.103,
    height: 15.984,
    viewBox: "0 0 14.103 15.984"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.11 8.037l-4.543 4.541a2.054 2.054 0 00-.544.959l-.353 1.408a.835.835 0 00.589 1.008.841.841 0 00.427.006l1.409-.351a2.089 2.089 0 00.959-.543l4.544-4.541a1.76 1.76 0 00-2.489-2.487zM1.884.47a.471.471 0 01.941 0v.47h2.351V.47a.471.471 0 01.941 0v.47h2.352V.47a.471.471 0 01.941 0v.47h.47a1.411 1.411 0 011.411 1.41v4.449a2.687 2.687 0 00-.844.573l-.1.1V2.354a.47.47 0 00-.47-.47H1.41a.473.473 0 00-.471.47v11.282a.472.472 0 00.471.47h3.5l-.153.615a1.8 1.8 0 00-.051.325h-3.3a1.411 1.411 0 01-1.411-1.41V2.354A1.412 1.412 0 011.406.944h.47zm.941 10.342a.472.472 0 01.47-.47h1.881a.47.47 0 110 .94H3.295a.465.465 0 01-.332-.137.47.47 0 01-.141-.333zm.47-3.291a.47.47 0 000 .94h4.7a.47.47 0 000-.94zm-.47-2.35a.472.472 0 01.47-.47h4.7a.47.47 0 110 .94h-4.7a.465.465 0 01-.332-.137.47.47 0 01-.141-.333z",
    fill: "#750b22"
  })));
}

export default SvgIkonaTerminarz;